import { useUserStore } from '@/stores/user'

import adminTools from './admin-tools'
import cases from './cases'
import funders from './funders'
import insuranceVerification from './insuranceVerification'
import medicaid from './medicaid'
import opportunities from './opportunities'
import patients from './patients'
import providers from './providers'
import ssdi from './ssdi'
import tasks from './tasks'

function redirectIfNotVector() {
  const user = useUserStore()
  if (user.data?.access?.vector !== true)
    window.location.href = import.meta.env.VITE_APP_URL
}

const vector = [
  {
    path: '/vector/dashboard',
    name: 'vector-home',
    component: () => import('@/pages/home/vector.vue'),
    meta: {
      title: 'Dashboard',
      resource: 'Vector',
      action: 'read',
      subject: 'Case',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/search',
    name: 'vector-search-results',
    component: () => import('@/pages/vector/searchResults.vue'),
    meta: {
      title: 'Search Results',
      resource: 'Vector',
      action: 'read',
      subject: 'Case',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  ...cases,
  ...providers,
  ...insuranceVerification,
  ...patients,
  ...funders,
  ...opportunities,
  ...adminTools,
  ...tasks,
  ...ssdi,
  ...medicaid,
]

export default vector
